import type { Vocabulary } from '@/i18n/vocabulary'

export type Portal = 'admin' | 'staff' | 'family'

export type SchoolType = 'primary' | 'secondary' | 'combined' | 'higher' | 'training'

export type Role =
  'super_admin' | 'admin' | 'teacher' | 'accountant' | 'librarian' | 'receptionist' | 'student' | 'parent'

export type Permission =
  | 'dashboard.view'
  | 'school.manage'
  | 'users.manage'
  | 'academic.view'
  | 'academic.manage'
  | 'students.view'
  | 'students.manage'
  | 'staff.view'
  | 'staff.manage'
  | 'attendance.view'
  | 'attendance.mark'
  | 'announcements.view'
  | 'announcements.manage'
  | 'finance.view'
  | 'finance.manage'
  | 'exams.view'
  | 'exams.manage'
  | 'marks.enter'
  | 'leave.manage'
  | 'leave.request'
  | 'library.view'
  | 'library.manage'
  | 'admissions.manage'
  | 'reports.view'
  | 'files.upload'
  | 'lms.teach'
  | 'lms.manage'
  | 'messaging.use'
  | 'messaging.manage'
  | 'courses.manage'
  | 'portal.staff'
  | 'portal.family'

export interface CurrentUser {
  id: number
  name: string
  email: string
  phone: string | null
  role: Role
  roleLabel: string
  isActive: boolean
  portals: Portal[]
  permissions: Permission[]
  lastLoginAt: string | null
  createdAt: string
  preferences: { locale: string; theme: string }
}

export interface SchoolSummary {
  id: number
  name: string
  shortName: string | null
  logoUrl: string | null
  currency: string
  timezone: string
  locale: string
  /** Optional modules turned on for the school (see features/school/modules.ts). */
  modules?: string[]
  /** False when the school works without guardians (student-only portal). */
  guardiansEnabled?: boolean
  /** Kind of institution (sets the default vocabulary). */
  type?: SchoolType
  /** How the school names learners, the year, classes and sections. */
  vocabulary?: Vocabulary
}

export interface Session {
  accessToken: string
  expiresIn: number
  portal: Portal
  user: CurrentUser
  school: SchoolSummary
}

export interface LoginInput {
  email: string
  password: string
  portal: Portal
  remember: boolean
}

export const portalHome: Record<Portal, string> = {
  admin: '/admin',
  staff: '/staff',
  family: '/portal',
}
